import { graphql } from '../../gql/index.ts';

const CompaniesQuery = graphql(/* GraphQL */ `
  query getCompanies {
    companiesForSessionUser {
      user {
        firstName
        lastName
        title
        email
        allowSevenDaysReminder
        allowOneDayReminder
      }
      companiesForUser {
        id
        privileges
        name
        domain
      }
    }
  }
`);

export { CompaniesQuery };
